import styled from 'styled-components';
import { Theme } from '@/styles/theme';
import { PaddingProps } from '@/types/ui';

const InputPanel = styled.div<{
  $padding?: PaddingProps;
  $rounded?: keyof Theme['rounded'];
  $height?: number | string;
}>`
  padding: ${(p) =>
    typeof p.$padding === 'object'
      ? `${p.theme.size[p.$padding.y]} ${p.theme.size[p.$padding.x]}`
      : p.theme.size[p.$padding ?? 'zero']};
  border: 1px solid transparent;
  background-color: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(4px);
  color: ${(p) => p.theme.colors.textWhite};
  ${(p) => p.theme.rounded[p.$rounded ?? 'md']};
  height: ${(p) =>
    typeof p.$height === 'string'
      ? p.$height
      : typeof p.$height === 'number'
        ? `${p.$height}px`
        : 'auto'};
`;

export default InputPanel;
